<mat-form-field class="controls-alignment" [formGroup]="group"  >
  <mat-label>{{field.labelName}}</mat-label>
  <input matInput [min]="minDate"
    [max]="currentDate"
    [formControlName]="field.labelCode"
    autocomplete="off"
    [matDatepicker]="picker1"
    [required]="isRequired" >
    <mat-datepicker #picker1> </mat-datepicker>
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    @if (group.get(field.labelCode).hasError('matDatepickerMax')) {
      <mat-error>{{ValidationMessages.dateValidation}}</mat-error>
    }
    @if (group.get(field.labelCode).hasError('matDatepickerMin')) {
      <mat-error>{{ValidationMessages.dateValidation}}</mat-error>
    }
    @if (group.get(field.labelCode).hasError('matDatepickerParse')) {
      <mat-error>{{ValidationMessages.invalidDateFormat}}</mat-error>
    }
    @for (validation of field.validations; track validation) {
      <ng-container ngProjectAs="mat-error">
        @if (group.get(field.labelCode).hasError(validation.name)) {
          <mat-error>{{validation.message}}</mat-error>
        }
      </ng-container>
    }
  </mat-form-field>


